import { Validation } from './Validation';


export default interface BirthdayTimeSlotJson {
   /**
    * Tageszeit zu der Geburtstage beginnen im Format hh:mm
    */
   beginTime: string,

   /**
    * Tageszeit zu der Geburtstage enden im Format hh:mm
    */
   endTime: string;

   /**
    * Gibt an, ob dieser Zeitslot nur zum Wochenende gebucht werden kann.
    */
   isWeekendOnly: boolean;
}

export function validateBirthdayTimeSlotJson(item: BirthdayTimeSlotJson) {
   return new Validation(item)
      .validateTime("beginTime")
      .validateTimeLaterTime("endTime", "beginTime")
      .finish();
}